import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-6 md:text-2xl text-lg font-medium text-neutral-600" }
const _hoisted_2 = { class: "md:inline-block block font-semibold text-neutral-900" }
const _hoisted_3 = { class: "w-full lg:p-6 p-4 mx-auto my-6 border border-gray-200 rounded" }
const _hoisted_4 = { class: "flex md:justify-between md:items-center md:flex-row flex-col" }
const _hoisted_5 = { class: "flex md:flex-row flex-col items-center md:space-x-3 md:space-y-0 space-y-3 md:mt-0 mt-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Search", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Add Perpetrator", -1)
const _hoisted_8 = { class: "mt-6" }
const _hoisted_9 = { class: "px-6 py-[18px] whitespace-nowrap text-sm text-gray-900" }
const _hoisted_10 = { class: "px-6 py-[18px] whitespace-nowrap text-sm text-gray-900" }
const _hoisted_11 = { class: "px-6 py-[18px] whitespace-nowrap text-sm text-gray-900" }
const _hoisted_12 = { class: "px-6 py-[18px] whitespace-nowrap text-sm text-gray-900" }
const _hoisted_13 = { class: "px-6 py-[18px] whitespace-nowrap text-sm text-gray-900" }
const _hoisted_14 = { class: "px-6 py-[18px] whitespace-nowrap text-sm text-gray-900" }
const _hoisted_15 = { class: "flex items-center justify-center mx-auto" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1 font-semibold text-white" }, "Link", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1 font-semibold text-white" }, "View", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1 font-semibold text-white" }, "View", -1)

import { computed, ref, watch } from "vue";
import UserLayout from "@/layouts/UserLayout.vue";
import SectionTitle from "@/components/partials/SectionTitle.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import { PlusIcon } from "@heroicons/vue/24/outline";
import DataTable from "@/components/partials/DataTable.vue";
import ViewButton from "@/components/buttons/ViewButton.vue";
import LinkButton from "@/components/buttons/LinkButton.vue";
import { useRouter, useRoute } from "vue-router";
import PerpetratorService from "@/classes/Perpetrators/PerpetratorService";
import { PerpetratorSearch } from "@/interfaces/Cases/Perpetrator";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import { errorResponse } from "@/helpers/errorMessage"; 
import pickBy from "lodash/pickBy";
import PageLoader from "@/components/loaders/PageLoader.vue"
import DateFormatter from "@/helpers/DateFormatter";
import { onIonViewWillEnter } from "@ionic/vue";
import { useRecordStatusChecker } from "@/store/recordStatusChecker";
import SearchTwoIcon from "@/components/icons/searchTwoIcon.vue";
import { useNetworkStore } from "@/store/network";
import PerpetratorProcessor from "@/classes/Perpetrators/Offline/Processor/PerpetratorProcessor";


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const loading = ref<boolean>(false);
const router = useRouter();
const route = useRoute();
const showSuccess = ref<boolean>(false);
const patientId = ref<number | null>(route.params.patient);
const caseId = ref<number | null>(route.params.case);
const items = ref<PerpetratorSearchIndex[]>([]);
const form = ref<PerpetratorSearch>({
	last_name: route.query?.last_name,
	first_name: route.query?.first_name,
	birthdate: router.query?.birthdate,
});
const errors = ref<object>({});
const offlineParams = ref<string>(route.query.offline);
const loaded = ref<boolean>(false);
const patient = ref<string>('');
const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);

const headers: { text: string; haveSort?: boolean }[] = [
	{ text: "Perpetrator Name" },
	{ text: "Birthdays" },
	{ text: "Age" },
	{ text: "Type" },
	{ text: "Latest Case No." },
];
const recordStatusChecker = useRecordStatusChecker();

const linkPerpetrator = async (item: object) => {
    const payload = isNetworkAvailable.value ? { perpetrator: item.id } : item;
    const response = await PerpetratorService.link(
		patientId.value,
		caseId.value,
		pickBy(payload),
        isNetworkAvailable.value
	);

    if (response?.status === 200 || response?.data != undefined) {
        recordStatusChecker.isCreatedPerpetrator = true;
        showSuccess.value = true;
        if (isNetworkAvailable.value) {
            item.case_perpetrator_id = response.data.data.id;
            await PerpetratorProcessor.syncToOffline(patientId.value, caseId.value, item);
        }
    } else {
        const error = response;
        errors.value = errorResponse(error.response?.data?.errors);
    }
};

const redirectSuccess = (): void => {
	showSuccess.value = false;
	router.replace(
		`/patient/${patientId.value}/cases/${caseId.value}/edit${offlineParams.value ? "?offline=true" : ""}`
	);
};

const getData = async (): Promise<any> => {
    form.value.is_searching = true;
    const response = await PerpetratorService.index(
		patientId.value,
		caseId.value,
		{ ...form.value },
        isNetworkAvailable.value,
	);
    
    if (response?.status === 200 || response?.data != undefined) {
     
		items.value = response.data.items;
		patient.value = response.data.patient;
       
        setTimeout(() => {
            loaded.value = true;
        }, 200);
    } else {
        const error = response;
        errors.value = errorResponse(error.response?.data?.errors);
        loaded.value = true;
    }
};

const setFormValue = () => {
    form.value.last_name = route.query?.last_name;
    form.value.first_name = route.query?.first_name;
    form.value.birthdate = router.query?.birthdate;
}

watch(
    () => isNetworkAvailable.value,
    () => {
        loading.value = false;
        getData();
    }
);

onIonViewWillEnter(async () => {
    recordStatusChecker.isCreatedPerpetrator = false;
    setFormValue();
    await getData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backLink: `/patient/${patientId.value}/cases/${caseId.value}/edit`
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, [
        _createTextVNode("Patient's Name: "),
        _createElementVNode("span", _hoisted_2, _toDisplayString(patient.value), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(SectionTitle, { title: "Search Perpetrator" }),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(ButtonComponent, {
              customClass: "quaternary md:w-auto w-full",
              size: "large",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).replace(`/patient/${patientId.value}/cases/${caseId.value}/perpetrators/search`)))
            }, {
              default: _withCtx(() => [
                _createVNode(SearchTwoIcon, { class: "object-contain w-5 h-5 mr-1 icon" }),
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(ButtonComponent, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (
							_unref(router).push(
								`/patient/${patientId.value}/cases/${caseId.value}/perpetrators/create`
							)
						)),
              customClass: "primary md:w-auto w-full md:mt-0 mt-6"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(PlusIcon), { class: "w-4 h-4 text-primary-600 stroke-[3px] -ml-2 mr-1 icon" }),
                _hoisted_7
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (loaded.value)
            ? (_openBlock(), _createBlock(DataTable, {
                key: 0,
                headers: headers,
                "no-action": false,
                count: items.value.data?.length,
                tableClass: "header-frm-table"
              }, {
                body: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.data, (item) => {
                    return (_openBlock(), _createElementBlock("tr", { key: item }, [
                      _createElementVNode("td", _hoisted_9, _toDisplayString(item.name), 1),
                      _createElementVNode("td", _hoisted_10, _toDisplayString(item?.birthdate ? _unref(DateFormatter).customDateFormat(item?.birthdate, 'MM/dd/yyy') : 'Unknown'), 1),
                      _createElementVNode("td", _hoisted_11, _toDisplayString(item?.computed_age), 1),
                      _createElementVNode("td", _hoisted_12, _toDisplayString(item.identity_meta?.description), 1),
                      _createElementVNode("td", _hoisted_13, _toDisplayString(item?.latest_case_number || 'NA'), 1),
                      _createElementVNode("td", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(LinkButton, {
                            onClick: ($event: any) => (linkPerpetrator(item)),
                            class: "shrink-0"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_16
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          (isNetworkAvailable.value)
                            ? (_openBlock(), _createBlock(ViewButton, {
                                key: 0,
                                routeLink: `/perpetrator/${item.id || item.offlineData?.offline_id}/view`,
                                target: "_blank",
                                "custom-class": "flex items-center justify-center w-full"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_17
                                ]),
                                _: 2
                              }, 1032, ["routeLink"]))
                            : _createCommentVNode("", true),
                          (!isNetworkAvailable.value)
                            ? (_openBlock(), _createBlock(ViewButton, {
                                key: 1,
                                onClick: ($event: any) => (_unref(router).push(`/perpetrator/${item.id || item.offlineData?.offline_id}/view`)),
                                "custom-class": "flex items-center justify-center w-full"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_18
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["count"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onConfirm: _cache[2] || (_cache[2] = ($event: any) => (redirectSuccess())),
        "action-text": "Close",
        title: "Perpetraror Linked",
        content: "Perpetraror successfully linked!"
      }, null, 8, ["show"]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
    ]),
    _: 1
  }, 8, ["backLink"]))
}
}

})